<template>
    <div class="bank">
        <div>
            <span>真实姓名</span>
            <input type="text" placeholder="请输入真实姓名" v-model="userInfo.real_name" disabled>
        </div>
        <div>
            <span>交易密码</span>
            <input type="password" placeholder="请输入银行卡交易密码" v-model="paypassword">
        </div>
        <div>
            <span>卡号</span>
            <input type="text" placeholder="请输入银行卡卡号" v-model="card">
        </div>
        <div>
            <span>开户行</span>
            <input type="text" placeholder="请输入银行卡开户地区名称" v-model="bank">
        </div>
        <button @click="submit">提交</button>
    </div>
</template>

<script>
    import {mapState} from "vuex"

    export default {
        props: {
            bankInfo: {
                default: null
            }
        },
        name: "bank",
        data() {
            return {
                name: "",
                paypassword: "",
                card: "",
                bank: "",
                status: 1,
            }
        },
        created() {
            if (this.bankInfo) {
                this.card = this.bankInfo.bankcard;
                this.bank = this.bankInfo.bank;
            }
        },
        watch: {
            bankInfo() {
                this.card = this.bankInfo.bankcard;
                this.bank = this.bankInfo.bank;
            }
        },
        computed: {
            ...mapState(["userInfo"])
        },
        methods: {
            submit() {
                let obj = {
                    card: this.card,
                    bank: this.bank,
                    paypassword: this.paypassword,
                    status: this.status,
                };
                this.ajax.post('appapi/c2c/setBank', obj).then((res) => {
                    if (res.data.code === 1) {
                        this.$toast(res.data.msg);
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
    .bank {
        padding: 0 39px;
        background: #fff;

        div {
            display: flex;
            align-items: center;
            padding: 44px 0 29px;
            border-bottom: 1px solid #F1F1F1;

            span {
                display: inline-block;
                width: 125px;
                margin-right: 54px;
                font-size: 30px;
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
            }

            input {
                flex: 1;
                height: 100%;
                border: none;
                outline: none;
                font-size: 24px;
            }
        }

        button {
            width: 100%;
            height: 86px;
            margin: 36px 0;
            font-size: 30px;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
            background: rgba(31, 194, 109, 1);
            border-radius: 10px;
        }
    }
</style>
